import React from 'react'
import PropTypes from 'prop-types'

import SkeletonWebsiteText from './SkeletonWebsiteText'

import { getUrlDomain } from '../../../../../helpers/url'

import { CLICK_THROUGH_LINK } from '../../../../../forms/Facebook/AdForms/fields'
import { LEAD_GENERATION_LINK } from '../../../../../forms/Facebook/AdForms/AdFacebookCreate/AdFacebookCreateForm/fields'

import useStyles from './styles'

function WebsiteText({ elementInProgress, formikValues }) {
  const classes = useStyles()

  // get the domain of the entered URL
  const urlDomain = getUrlDomain(formikValues[CLICK_THROUGH_LINK])

  if (urlDomain) {
    if (urlDomain === LEAD_GENERATION_LINK) {
      // if the preview is for a facebook lead generation ad, the URL displays as FB.ME but it should say FORM ON FACEBOOK for these types of ad
      return 'FORM ON FACEBOOK'
    } else {
      return urlDomain
    }
  } else {
    return <SkeletonWebsiteText count={1} className={classes.skeletonWebsiteText} />
  }
}

WebsiteText.propTypes = {
  elementInProgress: PropTypes.string,
  formikValues: PropTypes.object
}

export default WebsiteText
